<!-- 添加、编辑集控器弹框 -->
<template>
  <el-dialog
    title="新增集控器"
    :visible.sync="modalShow"
    width="825px"
    :before-close="modalClose"
  >
    <div style="margin-bottom:10px;">
        <el-button type="primary" size="mini"  v-show="isList" @click="handleAddList">批量添加</el-button>
        <el-button type="primary" size="mini"  v-show="!isList" @click="handleAdd">手动添加</el-button>
    </div>
    <div style="margin-bottom:5px;" v-show="!isList">
        <el-checkbox v-model="AllChecked" @change="handleAllCheck" style="margin-right:12px;"></el-checkbox>
        <el-button type="text" size="mini" @click="handleDeleteAll">删除选中</el-button>
        
    </div>
    <el-form class="gateway-item" :inline="true" :model="gatewayList" label-width="100px" ref="gatewayForm">
        <div v-for="(item,index) in gatewayList.List" :key="index">
            <el-form-item>
                <el-checkbox v-model="item.checked" @change="handleChange(item)"></el-checkbox>
            </el-form-item>
            <el-form-item label="序列号" 
                :prop="'List.'+index+'.deviceserial'"
                :rules="[{ required: true, message: '请输入序列号', trigger: 'blur' },{ min: 1, max: 100, message: '请输入1-100长度的序列号', trigger: 'blur'}]">
                <el-input style="width:150px;" :disabled="!isList" v-model="item.deviceserial" placeholder="请输入序列号"></el-input>
            </el-form-item>
            <el-form-item label="网关名称" label-width="80px" 
                :prop="'List.'+index+'.dev_name'"
                :rules="[{ required: true, message: '请输入网关名称', trigger: 'blur' },{ min: 1, max: 25, message: '请输入1-25长度的网关名称', trigger: 'blur'}]">
                <el-input style="width:130px;" v-model="item.dev_name" placeholder="请输入网关名称"></el-input>
            </el-form-item>
            <el-form-item label="网关备注" label-width="80px"
				:prop="'List.'+index+'.description'"
				:rules="{ min: 1, max: 128, message: '请输入1-120长度 的网关备注', trigger: 'blur'}"
			>
                <el-input style="width:130px;" v-model="item.description"></el-input>
            </el-form-item>
            <el-form-item v-show="!isList">
                <span class="delete-icon" @click="handledelete(index)"><i class="el-icon-delete"></i></span>
            </el-form-item>
        </div>
        <div style="text-align:right;">
            <el-button type="primary" @click="submit">确定并保存</el-button>
        </div>
    </el-form>
  </el-dialog>
</template>

<script>
import Service from '@/api/Service'
export default {
    name: "cmpgatewaydialog",
    inject: ["reload"],
    data() {
        return {
            gatewayList: {
                List: [{}]
            },  // 集控器列表
            AllChecked: false,  // 是否全选
            isList: true,  //  是否手动添加
        };
    },
    props: {
        modalShow: Boolean,
    },
    created() {
        
    },
    methods: {
        //   保存确认按钮
        async submit() {
            this.$refs['gatewayForm'].validate(async valid => {
                if(valid) {
                    let data
                    if(this.isList){
                        // 手动添加
                        let obj = this.gatewayList.List[0];
						let assigned_project_id = await Service.getProjectSystemId()
						this.gatewayList.List[0].assigned_project_id=assigned_project_id
                        data = await Service.addCollector(obj);
                    } else {
                        // 自动添加
                        let obj = this.gatewayList.List;
                        data = await Service.addCollectorList({list: obj});
                    }
                    if(data) {
                        this.$message({
                            type: 'success',
                            message: '添加成功!'
                        });
                        this.reload();
                    }
                } else {
                    return false
                }
            })
        },
        // 批量添加
        async handleAddList(){
            this.isList = false;
            // 获取在线集控器列表
            let data = await Service.getCollectorList();
			let assigned_project_id = await Service.getProjectSystemId()

            if(data == 'success'){
                this.$notify.info({
                    title: '消息',
                    message: '暂时没有可自动添加的集控器，请选择手动添加！',
                    duration: 3000,
                    onClose:()=>{
                        this.isList = true;
                    }
                });
                this.gatewayList.List = [{}]
            } else {
                let arr = [];
                data.map(v=>{
                    let obj = {};
                    obj.deviceserial = v.dev_serial;    //  序列号
                    obj.dev_name = '';    //  设备名
                    obj.description = ''; //  备注    
                    obj.ipaddress = v.ipaddress; //  IP地址
					obj.assigned_project_id = assigned_project_id
                    arr.push(obj);
                })
                this.gatewayList.List = arr;
            }
        },
        // 手动添加按钮
        handleAdd() {
            this.isList = true;
            this.gatewayList.List = [{}];
        },
        // 全选全部选
        handleAllCheck(val) {
            let data = JSON.parse(JSON.stringify(this.gatewayList.List))
            data.map(v => {
                v.checked = val
            })
            this.gatewayList.List = data
        },
        // 单选
        handleChange(item) {
            let Bool = true;  // 是否全选选中
            if (!item.checked) {
                Bool = false;
            } else {
                this.gatewayList.List.map(v=>{
                    if(!v.checked) {
                        Bool = false
                    }
                })
            }
            this.AllChecked = Bool;
        },
        // 删除选中
        handleDeleteAll() {
            this.gatewayList.List = this.gatewayList.List.filter(v => {
                return !v.checked;
            })
            this.AllChecked = false;
        },
        // 删除某一项集控器
        handledelete(index) {
            if (index <= 0) {
                return
            }
            this.gatewayList.List.splice(index,1);
        },
        //   关闭弹框
        modalClose() {
            // 清空表单信息
            this.$refs.gatewayForm.resetFields();
            this.$emit("update:modalShow", false);
        },
    },
};
</script>
<style lang='less' scoped>
.delete-icon{
    margin-left: 15px;
    cursor: pointer;
    i{
        font-size: 20px;
        vertical-align: middle;
    }
    &:hover{
        i{
            color:@primary-color;
        }
    }
}
.gateway-item{
    max-height: 600px;
    overflow-y: auto;
    .el-form-item{
        margin-bottom: 18px;
    }
}
</style>